
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bcks/invitation/guide",
      function () {
        return require("private-next-pages/bcks/invitation/guide/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bcks/invitation/guide"])
      });
    }
  